/**
 * @generated SignedSource<<1d56683d9d5a7aedd7433227eeceae83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PlaceholderWorkflowMenu_placeholder$data = {
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"PlaceholderSidePanel_placeholder">;
  readonly " $fragmentType": "PlaceholderWorkflowMenu_placeholder";
};
export type PlaceholderWorkflowMenu_placeholder$key = {
  readonly " $data"?: PlaceholderWorkflowMenu_placeholder$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlaceholderWorkflowMenu_placeholder">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PlaceholderWorkflowMenu_placeholder",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PlaceholderSidePanel_placeholder"
    }
  ],
  "type": "people",
  "abstractKey": null
};

(node as any).hash = "fc934376eca65bbbbae515742fa27f14";

export default node;
